
import breadcrumb from 'url-breadcrumb'

export default {
  name: 'Breadcrumbs',
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  computed: {
    breadcrumbs() {
      return breadcrumb(this.slug, {
        home: 'home',
        endingSlash: true,
        beautify: function (string) {
          return string.replaceAll('-', ' ').replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
          })
        },
      })
    },
    schema() {
      const base = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [],
      }

      this.breadcrumbs.forEach((crumb, index) => {
        base.itemListElement.push({
          '@type': 'ListItem',
          position: index + 1,
          name: crumb.NAME,
          item: 'https://echowave.io' + crumb.url,
        })
      })

      return base
    },
  },
}
